
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"9","height":"16"}},[_c('path',{attrs:{"d":"M8.859.115v2.538h-1.51c-1.183 0-1.404.567-1.404 1.385v1.817h2.817l-.375 2.846H5.945v7.298H3.003V8.701H.551V5.855h2.452V3.759c0-2.433 1.49-3.76 3.663-3.76 1.038 0 1.933.077 2.192.115z"}})])
      }
    
      }
    